import { useLocalStorage } from "@mantine/hooks";
import { usePrefab } from "@prefab-cloud/prefab-cloud-react";

const NEW_SECRETS_UI_ENABLED = "secrets.issue_parent_ui.enabled";

export const useHasNewSecretsUI = () => {
  const { isEnabled } = usePrefab();
  const [showNewSecretsUI, setShowNewSecretsUI] = useLocalStorage({
    key: "show-new-secrets-ui",
    defaultValue: true,
  });

  const isRolledOut = isEnabled(NEW_SECRETS_UI_ENABLED);

  return {
    showNewSecretsUI: showNewSecretsUI && isRolledOut,
    setShowNewSecretsUI,
    isRolledOut,
  };
};
